import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useNotifications } from 'lib/hooks/queries/notifications/useNotifications';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import ButtonActions from './components/ButtonActions';
import { DEFAULT_FILTERS, defaultColumns } from './lib/helper';

const Notifications = () => {
  const navigate = useNavigate();

  const practice = useRecoilValue(currentPractice);

  const onSelectRow = async (data) => navigate(data?.link);

  const columnDefs = useMemo(() => defaultColumns(practice.timezone), [practice.timezone]);

  return (
    <AgTablePage
      defaultColumns={columnDefs}
      defaultFilters={DEFAULT_FILTERS}
      useData={useNotifications}
      name="notifications"
      queryParams={{
        userPracticeNotifs: true,
        withal: { notifications: true, receiver: true, sender: true }
      }}
      rowStyle={{ cursor: 'pointer' }}
      actions={ButtonActions}
      onSelectRow={onSelectRow}
      queryOptions={{
        select: (data) => ({
          notifications: data?.data?.notifications || [],
          count: data?.data?.count || 0
        })
      }}
    />
  );
};

export default withErrorBoundary(Notifications);
